export default "__VITE_ASSET__369ba6a7__"